import { buildCallWorkbook } from './callExcel';
import axios from 'axios';

const baseURL = process.env.REACT_APP_DIALER_CRM_API_URL ||
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
        ? 'https://satkartarcrmcall.satkartar.me/' : 'https://satkartarcrmcall.satkartar.me/');

export const dialerCrmRequest = async (endpoint, data = {}, token = '') => {
    const response = await axios.post(`${baseURL.replace(/\/$/, '')}/dialer-crm/${endpoint}`, data, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        timeout: endpoint === 'push-lead' ? 45000 : 25000,
    });
    return response.data;
};

export const SESSION_KEY = 'dialerCrmSession';
export const PENDING_KEY = 'dialerCrmPendingOtp';

export const getDialerCrmSession = () => {
    try {
        const session = JSON.parse(sessionStorage.getItem(SESSION_KEY));
        return session?.user?.subadmin_id && /^[a-f0-9]{64}$/.test(session.token) &&
            session.expires_at * 1000 > Date.now() ? session : null;
    } catch {
        return null;
    }
};

export const getPendingOtp = () => {
    try {
        const pending = JSON.parse(sessionStorage.getItem(PENDING_KEY));
        return /^[6-9][0-9]{9}$/.test(pending?.mobile) && pending?.challenge &&
            pending.expiresAt > Date.now() ? pending : null;
    } catch {
        return null;
    }
};

export const savePendingOtp = (mobile, data) => {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify({
        mobile, challenge: data.challenge,
        resendAt: Date.now() + data.resend_after * 1000,
        expiresAt: Date.now() + data.expires_in * 1000,
    }));
};

export const requestError = error => error.response?.data?.msg || 'Unable to connect. Please try again.';

export const fetchAllCallRecords = async (filters, token) => {
    const response = await dialerCrmRequest('calls', { ...filters, all: true }, token);
    if (response.status !== 1) throw new Error(response.msg || 'Unable to load call data');
    const data = response.data;
    if (!Array.isArray(data?.rows) || !Array.isArray(data?.columns) || data.rows.length !== data.total) {
        throw new Error('Complete call data was not returned. Please update the backend and retry.');
    }
    return data;
};

export const downloadCallExcel = async (filters, token, loadedData) => {
    const data = loadedData || await fetchAllCallRecords(filters, token);
    if (data.total > 1048575) throw new Error('Too many records for one Excel sheet. Please narrow the date range.');
    const buffer = await buildCallWorkbook(data.columns, data.rows);
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const fileRange = `${filters.startDate}-${filters.endDate}`.replace(/[: ]/g, '-');
    link.download = data.kind === 'unmatched-calls'
        ? `unmatched-dialer-calls-${fileRange}.xlsx`
        : `dialer-calls-${fileRange}.xlsx`;
    document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};

